import { useState } from 'react';

const galleryImages = [
  {
    src: 'https://public.readdy.ai/ai/img_res/3eee57de4189c93dadaec078b0b2ff1e.jpg',
    label: 'Wedding Cake',
    span: 'row-span-2',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=assorted%20royal%20icing%20decorated%20sugar%20cookies%20pink%20white%20gold%20colors%20heart%20shapes%20flowers%20and%20monogram%20designs%20flat%20lay%20food%20photography%2C%20elegant%20bakery%20cookies%2C%20pastel%20colors%2C%20beautiful%20presentation%2C%20Valentines%20wedding%20bakery&width=400&height=300&seq=gal002&orientation=landscape',
    label: 'Custom Cookies',
    span: '',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=beautiful%20cake%20pops%20on%20sticks%20dipped%20in%20pink%20white%20and%20gold%20chocolate%20decorated%20with%20sprinkles%20and%20edible%20pearls%20elegant%20bakery%20display%2C%20professional%20food%20photography%2C%20creative%20desserts%2C%20party%20treats%2C%20sweet%20celebrations&width=400&height=300&seq=gal003&orientation=landscape',
    label: 'Cake Pops',
    span: '',
  },
  {
    src: 'https://static.readdy.ai/image/b56ddf5676badcd01c30e06215815ec0/9ca8537e7d8614358917eafe713ae7ff.jpeg',
    label: 'Signature Cheesecake',
    span: '',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=gorgeous%20birthday%20cake%20with%20ombre%20pink%20frosting%20rosette%20piping%20gold%20candles%20and%20edible%20flowers%20on%20white%20pedestal%20stand%2C%20beautiful%20celebration%20cake%2C%20professional%20bakery%20photography%2C%20elegant%20birthday%20party%20dessert%2C%20warm%20lighting&width=400&height=500&seq=gal005&orientation=portrait',
    label: 'Birthday Cake',
    span: 'row-span-2',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=rustic%20blueberry%20and%20peach%20lattice%20pie%20golden%20crust%20fresh%20berries%20filling%20on%20wooden%20board%20farmhouse%20style%20food%20photography%2C%20homemade%20bakery%20pie%2C%20Texas%20bakery%2C%20warm%20inviting%2C%20artisan%20pastry%2C%20delicious%20dessert&width=400&height=300&seq=gal006&orientation=landscape',
    label: 'Artisan Pies',
    span: '',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=elegant%20key%20lime%20mini%20pie%20with%20fresh%20whipped%20cream%20lime%20zest%20garnish%20on%20gold%20dessert%20plate%2C%20professional%20food%20photography%2C%20clean%20background%2C%20creamy%20dessert%2C%20bakery%20specialty%2C%20sophisticated%20presentation&width=400&height=300&seq=gal007&orientation=landscape',
    label: 'Key Lime Mini Pie',
    span: '',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=chocolate%20croissants%20and%20fresh%20baked%20pastries%20arranged%20beautifully%20on%20marble%20surface%20with%20powdered%20sugar%20dusting%20warm%20light%2C%20artisan%20bakery%20pastries%2C%20French%20patisserie%20style%2C%20flaky%20golden%20brown%2C%20elegant%20presentation&width=400&height=300&seq=gal008&orientation=landscape',
    label: 'Fresh Pastries',
    span: '',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=beautiful%20seasonal%20holiday%20Christmas%20cookies%20with%20royal%20icing%20in%20red%20green%20gold%20and%20white%20snowflake%20tree%20shapes%2C%20elegant%20holiday%20bakery%20treats%2C%20festive%20and%20beautiful%2C%20professional%20food%20photography%2C%20sweet%20celebrations%20holiday%20treats&width=400&height=300&seq=gal009&orientation=landscape',
    label: 'Seasonal Treats',
    span: '',
  },
];

export default function GallerySection() {
  const [hoveredIdx, setHoveredIdx] = useState<number | null>(null);

  return (
    <section id="gallery" className="py-20 md:py-28 bg-warm-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="h-px w-10 bg-gold-500" />
            <span className="text-gold-500 text-xs uppercase tracking-[0.25em] font-sans font-semibold">Our Sweet Creations</span>
            <div className="h-px w-10 bg-gold-500" />
          </div>
          <h2 className="font-serif text-4xl md:text-5xl text-charcoal-800 mb-4">
            Handcrafted with Love<br /><em className="italic text-blush-500">in Lubbock</em>
          </h2>
          <p className="text-warm-gray text-base max-w-xl mx-auto font-sans font-light leading-relaxed">
            Browse a selection of our custom cakes, cookies, pastries, and signature treats — each one made to order, just for you.
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 auto-rows-[200px]">
          {galleryImages.map((img, idx) => (
            <div
              key={idx}
              className={`relative overflow-hidden rounded-xl cursor-pointer group ${img.span}`}
              onMouseEnter={() => setHoveredIdx(idx)}
              onMouseLeave={() => setHoveredIdx(null)}
            >
              <img
                src={img.src}
                alt={img.label}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              <div
                className={`absolute inset-0 bg-blush-500/30 flex items-end p-4 transition-opacity duration-300 ${
                  hoveredIdx === idx ? 'opacity-100' : 'opacity-0'
                }`}
              >
                <span className="text-white font-serif text-base font-medium bg-charcoal-800/60 px-3 py-1 rounded-full">
                  {img.label}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Follow CTA */}
        <div className="text-center mt-12">
          <p className="text-warm-gray text-sm font-sans mb-4">See more of our latest creations on social media</p>
          <div className="flex items-center justify-center gap-4">
            <a
              href="https://www.instagram.com/sherry_sweet_celebrations/"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-2 border border-blush-400 text-blush-500 hover:bg-blush-500 hover:text-white px-6 py-3 rounded-full font-sans font-semibold text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-instagram-line" />
              Follow on Instagram
            </a>
            <a
              href="https://www.facebook.com/scbakeacake"
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="inline-flex items-center gap-2 border border-gold-500 text-gold-600 hover:bg-gold-500 hover:text-white px-6 py-3 rounded-full font-sans font-semibold text-sm transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-facebook-fill" />
              Follow on Facebook
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
